import { useEffect, useState } from "react";

const useDebounce = (value, delay = 500, initialTrigger = true) => {
    const [debouncedValue, setDebouncedValue] = useState(initialTrigger ? "" : value);
    let timerRef = null;

    useEffect(() => {
        timerRef = setTimeout(() => setDebouncedValue(value), typeof delay === "function" ? delay(value) : delay);
        
        return () => {
            clearTimeout(timerRef);
        };
    }, [value, delay]);

    return debouncedValue;
};

export default useDebounce;
